import { Component, inject } from '@angular/core';

import { NewAccountComponent } from '../../new-account.component';

@Component({
  selector: 'app-new-account-mobile-form-state',
  templateUrl: './new-account-mobile-form-state.component.html',
  styleUrls: [
    '../../shared-styles/new-account-device-view.component.scss',
    './new-account-mobile-form-state.component.scss',
  ],
  standalone: false,
})
export class NewAccountMobileFormStateComponent {
  public readonly newAccount = inject(NewAccountComponent);
}
